import { CustomLabelType } from '@/routes/sessions/redux/types';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export enum Granularity {
	Day,
	Hour
}

const getStart = (date: Date, granularity: Granularity) => {
	return granularity === Granularity.Day ? dayjs(date).startOf('day') : dayjs(date).startOf('hour');
};

const compare = (now: dayjs.Dayjs, due: dayjs.Dayjs, granularity: Granularity) => {
	const dif = dayjs.duration(now.diff(due));
	return Math.floor(granularity === Granularity.Day ? dif.asDays() : dif.asHours());
};

const difference = (dueDate: Date, todayDate: Date, granularity: Granularity) => {
	const startOfToday = getStart(todayDate, granularity);
	const startOfDueDate = getStart(dueDate, granularity);
	return compare(startOfToday, startOfDueDate, granularity);
};

const differenceInYears = (dueDate: Date, todayDate: Date) => {
	const todayYear = dayjs(todayDate).year();
	const dueDateYear = dayjs(dueDate).year();
	return todayYear - dueDateYear;
};

const dateFormat = (dueDate: Date, todayDate: Date, granularity: Granularity) => {
	const isToday = difference(dueDate, todayDate, Granularity.Day) === 0;
	const isThisYear = differenceInYears(dueDate, todayDate) === 0;
	const tmp = isToday ? '[Due Today]' : isThisYear ? 'MMM DD' : 'MMM DD, YYYY';

	const fmt = granularity === Granularity.Day ? tmp : tmp + ', h A';

	return dayjs(new Date(dueDate)).format(fmt);
};

export const formatDueDate = (dueDate: Date, todayDate: Date, granularity: Granularity) => {
	const type = difference(dueDate, todayDate, granularity) <= 0 ? CustomLabelType.base : CustomLabelType.danger;
	return { text: dateFormat(dueDate, todayDate, granularity), type };
};
